import { createTestIds } from '@/types/general'

export const NAVBAR_TEST_IDS = createTestIds({
	COMPONENT: 'navbar',
	NAVIGATION_ITEMS: 'navbar-navigation-items',
	NAVIGATION_ITEM: 'navbar-navigation-item',
	FEATURED_CARD: 'navbar-featured-card',
	FEATURED_CARD_LINK: 'navbar-featured-card-link',
	LOGIN_BUTTON: 'navbar-log-in-button',
	LOGO: 'navbar-logo',
	PRIMARY_BUTTON: 'navbar-primary-button',
	DROPDOWN_ITEM: 'navbar-dropdown-item',
	CATEGORY_COLUMN_SEE_MORE: 'navbar-category-column-see-more-link',
	CATEGORY_COLUMN_LINK: 'navbar-category-column-link',
	CATEGORY_COLUMN: 'navbar-category-column',
	CATEGORY_COLUMN_MOBILE: 'navbar-category-column-mobile',
	MOBILE_MENU_BUTTON: 'navbar-mobile-menu-button',
})

export const ERROR_VIEW_TEST_IDS = createTestIds({
	COMPONENT: 'error-view',
})

export const PAGINATION_TEST_IDS = createTestIds({
	COMPONENT: 'pagination',
	PAGINATION_PAGE: 'pagination-page',
	PAGINATION_PREVIOUS: 'pagination-previous',
	PAGINATION_NEXT: 'pagination-next',
})

export const TOC_LIST_TEST_IDS = createTestIds({
	COMPONENT: 'toc-list',
})

export const CK_EDITOR_TEST_IDS = createTestIds({
	COMPONENT: 'ck-editor-content',
})

export const ARTICLE_SIDEBAR_TEST_IDS = createTestIds({
	COMPONENT: 'article-sidebar',
	DOWNLOAD_LINK: 'article-sidebar-download-link',
})

export const AUTHOR_BLOCK_TEST_IDS = createTestIds({
	COMPONENT: 'author-block',
	LINK: 'author-block-link',
})

export const MEDIA_LINKS_TEST_IDS = createTestIds({
	COMPONENT: 'media-links',
	LINK: 'media-links-link',
})

export const BLOG_ARTICLES_TEST_IDS = createTestIds({
	COMPONENT: 'blog-articles',
})

export const BLOG_CARD_TEST_IDS = createTestIds({
	COMPONENT: 'blog-card',
	CARD_LINK: 'blog-card-link',
	CATEGORY_LINK: 'blog-card-category-link',
	AUTHOR_LINK: 'blog-card-author-link',
})

export const BLOG_CATEGORIES_ROW_TEST_IDS = createTestIds({
	COMPONENT: 'blog-categories-row',
	LINK: 'blog-categories-row-link',
})

export const BLOG_CONTENT_FOOTER_TEST_IDS = createTestIds({
	COMPONENT: 'blog-content-footer',
})

export const BLOG_HEADER_TEST_IDS = createTestIds({
	COMPONENT: 'blog-header',
	ARTICLE_LINK: 'blog-header-article-link',
	AUTHOR: 'blog-header-author',
	AUTHOR_LINK: 'blog-header-author-link',
	READ_TIME: 'blog-header-read-time',
})

export const BLOG_NAVIGATION_TEST_IDS = createTestIds({
	COMPONENT: 'blog-navigation',
	BLOG_LINK: 'blog-navigation-blog-link',
	CATEGORY_LINK: 'blog-navigation-category-link',
})

export const CATEGORY_HEADER_TEST_IDS = createTestIds({
	COMPONENT: 'category-header',
	NOT_FOUND: 'category-header-not-found',
})

export const EDITORS_PICK_TEST_IDS = createTestIds({
	COMPONENT: 'editors-pick',
	ARTICLE_LINK: 'editors-pick-article-link',
})

export const RELATED_ARTICLES_TEST_IDS = createTestIds({
	COMPONENT: 'related-articles',
	LIST: 'related-articles-list',
	SHOW_MORE: 'related-articles-show-more',
})

export const RELATED_POSTS_TEST_IDS = createTestIds({
	COMPONENT: 'related-posts',
	ARTICLE_LINK: 'related-posts-article-link',
})

export const SCROLL_PROGRESS_TEST_IDS = createTestIds({
	COMPONENT: 'scroll-progress',
	PROGRESS: 'scroll-progress-bar',
})

export const FOOTER_TEST_IDS = createTestIds({
	COMPONENT: 'footer',
	CASE_STUDY: 'footer-case-study',
	CASE_STUDY_LINK: 'footer-case-study-link',
	BOTTOM_FOOTER: 'footer-bottom-footer',
	MINIMAL_FOOTER: 'footer-minimal-footer',
})

export const SOCIAL_LINKS_TEST_IDS = createTestIds({
	COMPONENT: 'social-links',
	LINK: 'social-links-link',
})

export const FORMS_TEST_IDS = createTestIds({
	COMPONENT: 'forms',
	CONTACT_FORM: 'forms-contact-form',
	NEWSLETTER_FORM: 'forms-newsletter-form',
})

export const ARTICLE_SHARE_ICONS_TEST_IDS = createTestIds({
	COMPONENT: 'article-share-icons',
})

export const BLOG_POP_UP_TEST_IDS = createTestIds({
	COMPONENT: 'blog-pop-up',
	POP_UP_LINK: 'blog-pop-up-link',
})

export const COPY_CONTENT_TEST_IDS = createTestIds({
	COMPONENT: 'copy-content',
})

export const ICONS_SECTION_TEST_IDS = createTestIds({
	COMPONENT: 'icons-section',
	LINK: 'icons-section-link',
	IMAGE: 'icons-section-image',
})

export const TAG_TEST_IDS = createTestIds({
	COMPONENT: 'tag',
})

export const CHANGELOG_TEST_IDS = createTestIds({
	COMPONENT: 'changelog',
	ITEM: 'changelog-item',
	HISTORY: 'changelog-history',
	FILTERS: 'changelog-filters',
	FILTERS_ALL: 'changelog-filters-all',
	FILTERS_DATE: 'changelog-filters-date',
	CATEGORY: 'changelog-filters-category',
	CATEGORY_ALL: 'changelog-filters-category-all',
	NO_RESULTS: 'changelog-no-results',
	SEARCH_INPUT: 'changelog-search-input',
	SEARCH_CLEAR: 'changelog-search-clear',
})

export const CONVERSION_CARD_TEST_IDS = createTestIds({
	COMPONENT: 'conversion-card',
	IMAGE: 'conversion-card-image',
	LINK: 'conversion-card-link',
})

export const ENCOURAGE_SECTION_TEST_IDS = createTestIds({
	COMPONENT: 'encourage-section',
	PRIMARY_LINK: 'encourage-section-primary-link',
	SECONDARY_LINK: 'encourage-section-secondary-link',
})

export const ANIMATED_LOGOS_TEST_IDS = createTestIds({
	COMPONENT: 'animated-logos',
	PRIMARY_LINK: 'animated-logos-primary-link',
})

export const INFO_BANNER_TEST_IDS = createTestIds({
	COMPONENT: 'info-banner',
})

export const TEXT_COLUMNS_TEST_IDS = createTestIds({
	COMPONENT: 'text-columns',
})

export const TEXT_WITH_IMAGE_TEST_IDS = createTestIds({
	COMPONENT: 'text-with-image',
})

export const LIBRARY_COMPONENT_TEST_IDS = createTestIds({
	COMPONENT: 'library-grid',
	LINK: 'library-grid-link',
})

export const MOBILE_CATEGORY_NAVIGATION_TEST_IDS = createTestIds({
	COMPONENT: 'mobile-category-navigation',
	OPEN: 'mobile-category-navigation-open',
	CATEGORY_ITEM: 'mobile-category-navigation-category-item',
})
export const HERO_BANNER_TEST_IDS = createTestIds({
	COMPONENT: 'hero-banner',
	PRIMARY_LINK: 'hero-banner-primary-link',
	SECONDARY_LINK: 'hero-banner-secondary-link',
	LINK_UNDER_IMAGE: 'hero-banner-link-under-image',
})

export const PARTNERS_COMPONENT_TEST_IDS = createTestIds({
	COMPONENT: 'partners-grid',
	LINK: 'partners-grid-link',
})

export const CARDS_BANNER_TEST_IDS = createTestIds({
	COMPONENT: 'cards-banner',
})

export const FEATURE_BLOCK_TEST_IDS = createTestIds({
	COMPONENT: 'feature-block',
})
export const CARDS_BANNER_DARK_TEST_IDS = createTestIds({
	COMPONENT: 'cards-banner-dark',
})

export const CASE_STUDY_SIDEBAR_TEST_IDS = createTestIds({
	COMPONENT: 'case-study-sidebar',
})

export const APPS_TEST_IDS = createTestIds({
	COMPONENT: 'apps-grid',
})

export const HEADER_WITH_BACK_BUTTON_TEST_IDS = createTestIds({
	COMPONENT: 'header-with-back-button',
})

export const APPS_CATEGORIES_ROW_TEST_IDS = createTestIds({
	COMPONENT: 'apps-categories-row',
})

export const SIMILAR_APPS_TEST_IDS = createTestIds({
	COMPONENT: 'similar-apps',
})

export const BUTTON_SECTION_TEST_IDS = createTestIds({
	COMPONENT: 'button-section',
	BUTTON_LINK: 'button-section-button-link',
})

export const REVIEW_BANNER_TEST_IDS = createTestIds({
	COMPONENT: 'review-banner',
	LINK: 'review-banner-link',
})
export const CENTERED_BANNER_TEST_IDS = createTestIds({
	COMPONENT: 'centered-banner',
	PRIMARY_LINK: 'centered-banner-primary-link',
	SECONDARY_LINK: 'centered-banner-secondary-link',
})
export const MAIN_PAGE_BANNER_TEST_IDS = createTestIds({
	COMPONENT: 'main-page-banner',
	PRIMARY_LINK: 'main-page-banner-primary-link',
	SECONDARY_LINK: 'main-page-banner-secondary-link',
})

export const FAQ_SECTION_TEST_IDS = createTestIds({
	COMPONENT: 'faq-section',
	ACCORDION_TRIGGER: 'faq-section-accordion-trigger',
})

export const ORDER_FLOW_BLOCKS_SECTION_TEST_IDS = createTestIds({
	COMPONENT: 'order-flow-blocks-section',
})

export const REVIEW_CARD_LIST_TEST_IDS = createTestIds({
	COMPONENT: 'review-card-list',
})

export const STEPS_CARDS_TEST_IDS = createTestIds({
	COMPONENT: 'steps-cards',
	LINK: 'steps-cards-link',
})
export const FEATURE_BOX_TEST_IDS = createTestIds({
	COMPONENT: 'feature-box',
	LINK: 'feature-box-link',
})

export const TABLE_BANNER_TEST_IDS = createTestIds({
	COMPONENT: 'table-banner',
})

export const SCRIPT_TEST_IDS = createTestIds({
	COMPONENT: 'script',
})

export const SCROLLABLE_TRANSLATE_TILES_TEST_IDS = createTestIds({
	COMPONENT: 'scrollable-translate-tiles',
})

export const EXPANDABLE_FEATURES_LIST_TEST_IDS = createTestIds({
	COMPONENT: 'autoplay-features-list-section',
	FEATURE_TRIGGER: 'autoplay-features-list-trigger',
})

export const PRICING_TEST_IDS = createTestIds({
	COMPONENT: 'pricing',
	LIST: 'pricing-list',
	COMPARE: 'pricing-compare',
	CONTENT_TAB_TRIGGER: 'pricing-content-tab-trigger',
	CONTENT_TAB_CONTENT: 'pricing-content-tab-content',
	CONTENT_TAB: 'pricing-content-tab',
	COMPARE_CONTENT: 'pricing-compare-content',
	LIST_CONTENT: 'pricing-list-content',
	YEARLY_SWITCH: 'pricing-yearly-switch',
})

export const FEATURE_SET_TEST_IDS = createTestIds({
	COMPONENT: 'feature-set',
	TABS: 'feature-set-tabs',
	TABS_CONTENT: 'feature-set-tabs-content',
	TABS_TRIGGER: 'feature-set-tabs-trigger',
	TABS_LINK: 'feature-set-tabs-link',
	FEATURE_SET_CARD: 'feature-set-card',
})

export const MULTI_CARD_BANNER_TEST_IDS = createTestIds({
	COMPONENT: 'multi-card-section',
	FEATURE_BUTTON: 'multi-card-button',
})

export const COMPANY_CARDS_GRID_TEST_IDS = createTestIds({
	COMPONENT: 'company-cards-grid-section',
	CARD_BUTTON: 'company-cards-grid-button',
})

export const PLATFORMS_TABSET_TEST_IDS = createTestIds({
	COMPONENT: 'platforms-tabset',
})
export const CASE_STUDIES_FILTERS_TEST_IDS = createTestIds({
	COMPONENT: 'case-studies-filters-section',
	FILTER_TRIGGER: 'case-studies-filters-combobox',
	FILTER_APPLY_FILTERS: 'case-studies-filters-apply-filters',
	FILTER_CLEAR_FILTERS: 'case-studies-filters-clear-filters',
	CASE_STUDY_LINK: 'case-studies-filters-link',
})

export const SELECTED_CASE_STUDIES_TEST_IDS = createTestIds({
	COMPONENT: 'selected-case-studies',
})

export const MARKETO_FORM_SECTION_TEST_IDS = createTestIds({
	COMPONENT: 'marketo-form-section',
})

export const CONTENT_WITH_IMAGE_TAB_TEST_IDS = createTestIds({
	COMPONENT: 'content-with-image-tab',
	TABS: 'content-with-image-tab-tabs',
	TABS_CONTENT: 'content-with-image-tab-tabs-content',
	TABS_TRIGGER: 'content-with-image-tab-tabs-trigger',
})
